import prostor from './views/prostor.js';
export default prostor;
